"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PERMISSION_LABELS = void 0;
/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ What each permission action is called, in both languages.                 │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * ⚠️ **Shared, so the permissions screen and the role-change email say the same words.** Phase 5 of
 * `docs/plan/notification-emails.md` moved these here from the web catalogue — the email lists the
 * actions a new role grants, and two copies of a label is how a screen and an email come to
 * disagree about what a permission is called.
 *
 * ⚠️ **Exhaustive over `ActionKey`**, so a new action is a type error until it has both words.
 */
exports.PERMISSION_LABELS = {
    'task.view': { hu: 'Feladatok megtekintése', en: 'View tasks' },
    'task.create': { hu: 'Feladat létrehozása', en: 'Create a task' },
    'task.update': { hu: 'Feladat szerkesztése', en: 'Edit a task' },
    'task.assign': { hu: 'Felelős állítása', en: 'Set the assignee' },
    'task.schedule': { hu: 'Ütemezés és függőségek', en: 'Scheduling and dependencies' },
    'task.delete': { hu: 'Feladat törlése', en: 'Delete a task' },
    'worklog.read': { hu: 'Rögzítések megtekintése', en: 'View worklogs' },
    'worklog.create': { hu: 'Rögzítés felvétele', en: 'Log time' },
    'worklog.update': { hu: 'Rögzítés módosítása', en: 'Edit a worklog' },
    'worklog.lock': { hu: 'Zárónap állítása', en: 'Set the lock date' },
    'project.view': { hu: 'Projektek megtekintése', en: 'View projects' },
    'project.manage': { hu: 'Projekt szerkesztése', en: 'Edit a project' },
    'project.create': { hu: 'Projekt létrehozása', en: 'Create a project' },
    'project.finance': { hu: 'Pénzügyi dashboard megtekintése', en: 'View the finance dashboard' },
    'client.view': { hu: 'Ügyfelek megtekintése', en: 'View clients' },
    'client.manage': { hu: 'Ügyfél szerkesztése', en: 'Edit a client' },
    'contract.view': { hu: 'Szerződések megtekintése', en: 'See contracts' },
    'contract.manage': { hu: 'Szerződés szerkesztése', en: 'Edit a contract' },
    'lineitem.manage': { hu: 'Sortételek kezelése', en: 'Manage line items' },
    'people.view': { hu: 'Dolgozók megtekintése', en: 'View people' },
    'people.manage': { hu: 'Dolgozó szerkesztése', en: 'Edit a person' },
    'people.onboard': { hu: 'Meghívás és onboarding', en: 'Invite and onboard' },
    'people.deactivate': { hu: 'Dolgozó inaktiválása', en: 'Deactivate a person' },
    'leave.view': { hu: 'Mindenki kérelmeinek megtekintése', en: 'See everybody’s requests' },
    'leave.decide': { hu: 'Kérelem elbírálása', en: 'Decide a request' },
    'leave.request': { hu: 'Szabadság kérése', en: 'Request leave' },
    'report.view': { hu: 'Riportok megtekintése', en: 'View reports' },
    'report.manage': { hu: 'Riport mentése', en: 'Save a report' },
    'report.export': { hu: 'Export', en: 'Export' },
    'report.money': { hu: 'Pénzes riportok', en: 'Money reports' },
    'settings.view': { hu: 'Beállítások megtekintése', en: 'View settings' },
    'settings.manage': { hu: 'Beállítások szerkesztése', en: 'Edit settings' },
    'integration.manage': { hu: 'Integrációk', en: 'Integrations' },
    'billing.manage': { hu: 'Előfizetés és számlázás', en: 'Subscription and billing' },
    'audit.view': { hu: 'Auditnapló megtekintése', en: 'View the audit log' },
    'workspace.create': { hu: 'Munkaterület létrehozása', en: 'Create workspace' },
    /* 20 Oct 2026 · Phase 6 · DM-1. */
    'deal.view': { hu: 'Dealek megtekintése', en: 'View deals' },
    'deal.manage': { hu: 'Dealek kezelése', en: 'Manage deals' },
    /* 22 Oct 2026 · the workspace menu's rows, and the dashboards. */
    'menu.projects': { hu: 'Munkaterület projektlistája', en: 'Workspace project list' },
    'menu.tasks': { hu: 'Munkaterület feladatlistája', en: 'Workspace task list' },
    'menu.contracts': { hu: 'Munkaterület szerződéslistája', en: 'Workspace contract list' },
    'menu.invoices': { hu: 'Munkaterület számlalistája', en: 'Workspace invoice list' },
    'menu.worklogs': { hu: 'Munkaterület időloglistája', en: 'Workspace worklog list' },
    'menu.people': { hu: 'Munkaterület dolgozólistája', en: 'Workspace people list' },
    'menu.clients': { hu: 'Munkaterület ügyféllistája', en: 'Workspace client list' },
    'dashboard.resource': { hu: 'Erőforrás dashboard', en: 'Resource dashboard' },
    'dashboard.logging': { hu: 'Logolás dashboard', en: 'Logging dashboard' },
    'dashboard.utilization': { hu: 'Utilizáció dashboard', en: 'Utilisation dashboard' },
    'dashboard.leave': { hu: 'Szabadságok dashboard', en: 'Leave dashboard' },
};
//# sourceMappingURL=labels.js.map